import { trans } from '@pepita-i18n/babelfish';
import gtxConstants from '@getrix/common/js/gtx-constants';

import { immobiliareBaseUrl } from './immobiliareBaseUrl';

export const SecurityHeader = ({ customer }) => {
    return (
        <div className="login-header">
            <a href={immobiliareBaseUrl} className="login-header__logo">
                <img
                    className="login-header__logo-default"
                    src={`/bundles/base/getrix/common/img/country/${gtxConstants(
                        'COUNTRY_TAG'
                    )}/logo/logo.svg`}
                    alt="logo"
                />
                <img
                    className="login-header__logo-reversed"
                    src={`/bundles/base/getrix/common/img/country/${gtxConstants(
                        'COUNTRY_TAG'
                    )}/logo/logo_reversed.svg`}
                    alt="logo"
                />
            </a>
            <div className="login-header__action">
                {customer ? (
                    <>
                        <span className="pubblica-annunci gx-body-small">
                            {trans('login.header.customer')}
                        </span>
                        <a className="gx-button" href="/signin">
                            {trans('btn.label.login')}
                        </a>
                    </>
                ) : (
                    <>
                        <span className="pubblica-annunci gx-body-small">
                            {trans('login.header.not_customer')}
                        </span>
                        <a className="gx-button" href="/signup">
                            {trans('btn.label.sign_in')}
                        </a>
                    </>
                )}
            </div>
        </div>
    );
};
